import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFullScreen = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	enableBackground: "new 0 0 32 32",
	height: 512,
	viewBox: "0 0 32 32",
	width: 512,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "m13.777 17.223c-.256 0-.512.098-.707.293l-8.07 8.071v-4.657c0-.553-.447-1-1-1s-1 .447-1 1v7.07c0 .553.447 1 1 1h7.07c.553 0 1-.447 1-1s-.447-1-1-1h-4.655l8.069-8.07c.391-.391.391-1.023 0-1.414-.195-.196-.451-.293-.707-.293z" }), /* @__PURE__ */ _jsx("path", { d: "m28.111 3.111h-7.07c-.553 0-1 .447-1 1s.447 1 1 1h4.656l-8.182 8.182c-.391.391-.391 1.023 0 1.414s1.023.391 1.414 0l8.182-8.182v4.656c0 .553.447 1 1 1s1-.447 1-1v-7.07c0-.552-.447-1-1-1z" })] })
});
export default SvgFullScreen;
